// src/pages/SwimInstructor.jsx
import CourseSchedule from '../components/CourseSchedule';

const sessions = [
  {
    title: "Swim Instructor Course",
    date: "June 10 – June 14, 2025",
    time: "Mon–Fri, 9am–3pm",
    location: "Etobicoke Community Pool",
    price: 300
  },
  {
    title: "Swim Instructor Evening",
    date: "July 15 – July 26, 2025",
    time: "Weeknights, 6pm–9pm",
    location: "Scarborough Aquatic Centre",
    price: 320
  }
];

const SwimInstructor = () => (
  <div className="bg-white text-gray-900 font-sans">
    <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-blue-800">Swim Instructor Certification</h1>
      <p className="text-lg mb-4">
        Learn to teach swimmers of all ages with confidence. This program includes...
      </p>
    </section>

    <CourseSchedule sessions={sessions} />
  </div>
);

export default SwimInstructor;
